import { useEffect, useState } from "react";

interface UserProperties {
  userType: string;
  aaId: string;
  ssoId: string;
  cas: string;
}

interface AuthUserProps {
  firstName: string;
  lastName: string;
  peep_analyticsid?: string;
  ssoId?: string;
  casId?: string;
  customerNumber?: string;
  isVendor?: boolean;
  userType?: string;
  roles?: string[];
}

const useUserDataAnalytics = (
  auth0User: AuthUserProps,
  serverAnalyticsProps: UserProperties,
  isToUseAuthZero: boolean
) => {
  const [userAnalyticsData, setUserAnalyticsData] =
    useState<UserProperties | null>(null);

  useEffect(() => {
    if (
      auth0User?.casId &&
      auth0User?.ssoId &&
      auth0User?.userType &&
      auth0User?.peep_analyticsid
    ) {
      setUserAnalyticsData({
        userType: auth0User?.userType,
        aaId: auth0User?.peep_analyticsid,
        ssoId: auth0User?.ssoId,
        cas: auth0User?.casId,
      });
    } else if (
      !isToUseAuthZero &&
      serverAnalyticsProps.aaId &&
      serverAnalyticsProps.ssoId &&
      serverAnalyticsProps.userType &&
      serverAnalyticsProps.cas
    ) {
      setUserAnalyticsData({
        userType: serverAnalyticsProps.userType,
        aaId: serverAnalyticsProps.aaId,
        ssoId: serverAnalyticsProps.ssoId,
        cas: serverAnalyticsProps.cas,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth0User, isToUseAuthZero]);

  return { userAnalyticsData, setUserAnalyticsData };
};

export default useUserDataAnalytics;
